<template>
  <el-dialog
    title="修改密码"
    :visible.sync="visible"
    width="600px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="onClose"
  >
    <el-form
      :model="formModel"
      :rules="rules"
      ref="formModel"
      label-width="100px"
    >
      <el-form-item label="旧密码" prop="old_password">
        <el-input
          type="password"
          v-model="formModel.old_password"
          autocomplete="new-password"
        ></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="new_password">
        <el-input
          type="password"
          v-model="formModel.new_password"
          autocomplete="new-password"
        ></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="new_password_confirm">
        <el-input
          type="password"
          v-model="formModel.new_password_confirm"
          autocomplete="new-password"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="onConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      rules: {
        old_password: [
          { required: true, message: "请输入旧密码", trigger: "blur" }
        ],
        new_password: [
          { required: true, message: "请输入新密码", trigger: "blur" }
        ],
        new_password_confirm: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (!value.trim()) {
                return callback(new Error("确认新密码不能为空"));
              }
              if (value !== this.formModel.new_password) {
                return callback(new Error("两次输入密码不一致"));
              }
              return Promise.resolve();
            }
          }
        ]
      },
      formModel: {}
    };
  },
  methods: {
    onOpen() {
      this.visible = true;
    },
    onClose() {
      this.formModel = {};
    },
    onConfirm() {
      this.$refs.formModel.validate(v => {
        if (v) {
          this.$confirm("确认修改用户密码?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(async () => {
            await this.$common.http({
              url: "/api/pcenter/reset_password",
              data: {
                ...this.formModel,
                password_level: 3
              }
            });
            this.visible = false;
            this.$message.success("密码修改成功");
            if (this.$route.path !== "/rhqy/home/view") {
              this.$router.push("/rhqy/home/view");
            }
          });
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
input:-webkit-autofill {
-webkit-box-shadow: 0 0 0px 1000px white inset;
background-color: white;
}
</style>
